import 'jquery'
import './vendors/waypoint'
import './vendors/owl.carousel.min'
import './vendors/select2.min'
import './vendors/slick-slider'
import './vendors/youtube.iframe.api'



  let sm = 576;
  let md = 768;
  let lg = 992;
  let xl = 1360;
  let screen_width = $(window).width()

  let body = $('body');
  let customSelectSpeed = 'fast';

  //close menu if opened
  body.click(function (e) {
    let menuWithChildren = $('.menu-item-has-children')
    if(e.target.tagName.toLowerCase() !== 'a') {
      menuWithChildren.removeClass('opened')
    }
  })

  //label animation class
  body.on('change', 'input[type="text"], input[type="email"], input[type="password"], textarea', function(e){
    $(this).val().trim().length > 0 ? $(this).addClass('with-value') : $(this).removeClass('with-value');
  })

  //custom select
  body.on('click', '.custom-select .selector', function(e){
    $(this).parent().toggleClass('opened')
    $(this).parent().find('.selectors').slideToggle(customSelectSpeed)
  })


  body.on('click', '.custom-select .item', function(e){

    let item = $(this);
    let selected = item.closest('.custom-select');

    selected.find('.selected-item-text').html(item.html());
    selected.find('.selected-item-value').val(item.attr('value'))

    selected.toggleClass('opened')
    selected.find('.selectors').slideToggle(customSelectSpeed)
    selected.find('.selector').addClass('selected')

  });

  body.on('change', 'select', function (e) {
    let select = $(this)
    let options = $(this).find('option')

    options.removeClass('selected')
    select.val().length > 0 ?  select.addClass('selected') : select.removeClass('selected')
    select.find('option:selected').addClass('selected')
  })


  //main-menu
  body.on('click', '.menu-item-has-children a', function (e) {
    let element = $(this)
    let menuWithChildren = $('.menu-item-has-children')
    let parentBlock = $(this).parent()
    let parentsContainer = parentBlock.parent()

    if(parentsContainer.hasClass('footer-links')) {
      if(element.attr('href').length < 10) {
        e.preventDefault()
      }

    } else if(parentBlock.hasClass('menu-item-has-children')) {

      e.preventDefault();

      if(parentBlock.hasClass('opened')) {
        menuWithChildren.removeClass('opened')
        parentBlock.removeClass('opened')
      } else {
        menuWithChildren.removeClass('opened')
        parentBlock.addClass('opened')
      }
    }
  })

  //mobile menu
  body.on('click', '#open-mobile-menu', function (e) {
    $('header').addClass('opened')
  })
  body.on('click', '#close-mobile-menu', function (e) {
    $('header').removeClass('opened')
  })

  let close_menu_timeout = null;

  if(screen_width > lg) {

    $('.menu-item-has-children').addClass('js-menu-open')
    $('.sub-menu').addClass('js-menu-open')

    /*body.on('mouseenter', '.js-menu-open', function(e) {
      clearTimeout(close_menu_timeout);
      $(this).addClass('opened')
    })
    body.on('mouseleave', '.js-menu-open', function(e) {
      let menu_item = $('.opened')
      clearTimeout(close_menu_timeout);
      close_menu_timeout = setTimeout(function() {
        menu_item.removeClass('opened')
      }, 600)
    })*/

    const menuItems = document.querySelectorAll('.js-menu-open')

    menuItems.forEach(menuItem => {
      menuItem.addEventListener('mouseenter', function () {
        menuItem.classList.add('opened')
      })

      menuItem.addEventListener('mouseleave', function () {
        console.log('close-menu')
        menuItem.classList.remove('opened')
      })
    })


  }




  /* Video slider */



  let loop = $('.loop')
  let initial_load = true
  let center_video = $('.owl-item.big video');
  let owl_videos = $('.video-slider-content').attr('data-total-video')

  loop.on('initialized.owl.carousel translate.owl.carousel', function(e){
    let idx = e.item.index;
    $('.owl-item.center-right').removeClass('center-right');
    $('.owl-item.center-left').removeClass('center-left');
    $('.owl-item.center-second-left').removeClass('center-second-left');
    $('.owl-item.center-second-right').removeClass('center-second-right');
    $('.owl-item.big').removeClass('big');
    $('.owl-item').eq(idx).addClass('big');
    $('.owl-item').eq(idx-1).addClass('center-left');
    $('.owl-item').eq(idx-2).addClass('center-second-left');
    $('.owl-item').eq(idx+1).addClass('center-right');
    $('.owl-item').eq(idx+2).addClass('center-second-right');

      if(initial_load) {
        let all_videos = $('.owl-item video')
        all_videos.each(function () {
          $(this).get(0).pause()
        })
        initial_load = false
      }

      center_video = $('.owl-item.big video');

      center_video.get(0).play()

    if(screen_width < lg || owl_videos > 5) {
      center_video.get(0).addEventListener('ended',playNext,false)
    } else {
      center_video.get(0).addEventListener('ended',replay,false)
    }

  });

  function replay () {
    all_videos = $('.owl-item.big video')
    all_videos.each(function () {
      $(this).get(0).currentTime = 0
      $(this).get(0).play()
    })
  }

  function playNext () {
    center_video.get(0).pause()
    $('.owl-next').click()
  }


  let front_video_slider = loop.owlCarousel({
    center: true,
    loop:true,
    nav:true,
    navText: ['<div class="video-slider-nav left"><span class="icon icon-angle-left"></span></div>', '<div class="video-slider-nav right"><span class="icon icon-angle-right"></span></div>'],
    margin:0,
    autoPlay: 2000,
    responsiveClass:true,
    responsive:{
      0: {
        items: 1
      },
      576: {
        items: 3
      },
      992: {
         items:5,
       }
    }
  });

  front_video_slider.owlCarousel();
  front_video_slider.on('changed.owl.carousel', function(event) {
    center_video.get(0).pause()
  })


  if(screen_width > sm) {
    let front_video_block = $(".video-slider-content .video-storage").hover(hoverVideo, hideVideo);
  }

  function hoverVideo(e) {
    let has_file_video = $(this).find('video').length
    if(has_file_video) {

      //centered video play
      //center_video = $('.owl-item.center video');
      center_video.get(0).pause()

      let hover_class = get_hovered_slider($(this))
      if(hover_class !== 'big') { $('.owl-item.big').removeClass('big'); }
      $('.owl-item.' + hover_class).addClass('big')
      $(this).closest('.owl-carousel').addClass('hovered-' + hover_class)
      $('video', this).get(0).play();
    }
  }

  function hideVideo(e) {
    let has_file_video = $(this).find('video').length
    if(has_file_video) {
      let hover_class = get_hovered_slider($(this))
      $('.owl-item.' + hover_class).removeClass('big')
      $('.owl-item.center').addClass('big');
      $(this).closest('.owl-carousel').removeClass('hovered-' + hover_class)
      $('video', this).get(0).pause();

      //centered video play
      center_video = $('.owl-item.center video');
      if(center_video) {
        center_video.get(0).play()
      }

    }
  }

  let auto_play_slider = $('.video-slider-content .owl-item.center.big video')
  let auto_play_solution_video = $('.side-video-large video')

  if(auto_play_slider.length) {
    auto_play_slider.get(0).play();
  }
  if(auto_play_solution_video.length) {
    auto_play_solution_video.get(0).play();
  }

  //let solutions_sliders = $('.side-video').hover( hoverSideVideo, hideSideVideo );

  function hoverSideVideo(e) {
    let has_file_video = $(this).find('video').length
    if(has_file_video) {
      $('video', this).get(0).play();
    }
  }

  function hideSideVideo(e) {
    let has_file_video = $(this).find('video').length
    if(has_file_video) {
      $('video', this).get(0).pause();
    }
  }


  function get_hovered_slider(elem)
  {
    let classes = elem.closest('.owl-item')

    if(classes.hasClass('center-second-left')) {
      return 'center-second-left';
    } else if(classes.hasClass('center-left')) {
      return 'center-left';
    } else if(classes.hasClass('center-right')) {
      return 'center-right';
    } else if(classes.hasClass('center-second-right')) {
      return 'center-second-right';
    }
    return 'big';

  }

  if($('.video-slider-content').length) {
    let minheight = 50
    $('.owl-item').each(function (e) {
      if(!$(this).hasClass('big')) {
        let textheight = $(this).find('.video-text').height()
        minheight = textheight > minheight ? textheight : minheight
      }
    })
    $('.video-storage .video-text').css('height', minheight);
  }




  /* EOF Video slider */


  /* Elements */

  body.on('click', '.video-play-button', function (e) {
    let button = $(this)
    let videoBlock = button.closest('.video-block')
    let coverImage = videoBlock.find('.video-cover-image')
    let iframe = videoBlock.find('iframe')
    let video = videoBlock.find('video')
    let autoplaySrc = iframe.attr('src') + '&autoplay=1;mute=1'

    iframe.css('height', videoBlock.height())
    iframe.attr('src', autoplaySrc)
    coverImage.hide()
    button.hide()
    iframe.show()
    video.show()


  })

  /* Sliders */


  let stairs_down_slider = $('.stairs-down-slider')
  if(stairs_down_slider.length) {
    stairs_down_slider.slick({
      autoPlay: false,
      slidesToShow: 3,
      arrows: false,
      draggable: false,
      infinite: false,
      responsive: [
        {
          breakpoint: lg,
          settings: {
            slidesToShow: 2,
            draggable: true,
            dots: true
          }
        },
        {
          breakpoint: sm,
          settings: {
            slidesToShow: 1,
            draggable: true,
            dots: true
          }
        }
      ]
    });
  }

  $('.slick-slider').each(function () {
    let slickHeight = $(this).find('.slick-track')
    $(this).css('height', slickHeight)
  })


  /***************************************/

  let image_gallery_slider = $('.image-gallery-slider')
  if(image_gallery_slider.length) {
    image_gallery_slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      pauseOnHover : false,
      responsive: [
        {
          breakpoint: lg,
          settings: {
            slidesToShow: 2,
            draggable: true,
            dots: true
          }
        },
        {
          breakpoint: sm,
          settings: {
            slidesToShow: 1,
            draggable: true,
            dots: true,
            centerMode : true,
            centerPadding : '24px'
          }
        }
      ]
    })
  }

  /***************************************/

  let three_column_slider = $('.three-column-slider')
  if(three_column_slider.length) {
    three_column_slider.slick({
      autoPlay: false,
      slidesToShow: 3,
      arrows: false,
      draggable: false,
      infinite: false,
      responsive: [
        {
          breakpoint: lg,
          settings: {
            slidesToShow: 2,
            draggable: true,
            dots: true
          }
        },
        {
          breakpoint: sm,
          settings: {
            slidesToShow: 1,
            draggable: true,
            dots: true,
          }
        }
      ]
    })
  }

  /**************************************/

  let case_study_categories_menu_slider = $('.case-study-categories-menu-slider')
  if(case_study_categories_menu_slider.length) {
    let active_index = 0;
    if($(window).width() < sm) {
      active_index = case_study_categories_menu_slider.find('a.active').attr('data-order')
    }
    case_study_categories_menu_slider.slick({
      autoPlay: false,
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 1,
      variableWidth: true,
      initialSlide: active_index,
      responsive: [
        {
          breakpoint: sm,
          settings: {
            //centerMode: true,
            //centerPadding: '40px',
          }
        },
      ]
    })
  }

  /**************************************/

  let blog_categories_menu_slider = $('.blog-categories-menu-slider')
  if(blog_categories_menu_slider.length) {
    let active_index = 0;
    if($(window).width() < sm) {
      active_index = blog_categories_menu_slider.find('a.active').attr('data-order')
    }
    blog_categories_menu_slider.slick({
      autoPlay: false,
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 1,
      variableWidth: true,
      initialSlide: active_index,
      responsive: [
        {
          breakpoint: sm,
          settings: {
            //centerMode: true,
            //centerPadding: '40px',
          }
        },
      ]
    })
  }



  /* Waypoints */

  $('.video-block').waypoint(function(direction) {

    let element = $(this.element)
    let iframe = element.find('iframe')
    let iframe_container = element.find('.iframe-container')
    let iframe_video_src = element.attr('data-video-src')
    let file_video = element.find('video')
    let file_video_src = file_video.attr('data-src')
    let video_source = element.find('source')

    iframe.attr('src', iframe_video_src)
    //video_source.attr('src', file_video_src)

    iframe.css('height', iframe_container.outerHeight())

    if(element.hasClass('auto-play')) {
      let coverImage = element.find('.video-cover-image')
      coverImage.hide()
      iframe.show()
    }

  }, {
    offset: '280%',
    triggerOnce: true
  })

 /* Lazy images */

  function getLazyLoadDataFieldByScreenSize() {

    let imgSize = 'full';
    if($(window).width() <= 600) {
      imgSize = 600;
    } else if($(window).width() <= 1024) {
      imgSize = 1024;
    }
    return 'data-lazy-image-' + imgSize;
  }

  let lazyLoadDataField = getLazyLoadDataFieldByScreenSize();

  function changeLazyLoadImage(element) {
    let lazyImageSrc = element.attr(lazyLoadDataField);
    if(element.hasClass('lazy-bg')) {
      element.css('background-image', 'url('+lazyImageSrc+')');
    } else {
      element.attr('src', lazyImageSrc);
    }
  }

  $('.lazy-load').waypoint(function(direction) {

    let element = $(this.element)
    changeLazyLoadImage(element);

  }, {
    offset: '200%',
    triggerOnce: true
  })


  /* Block - Accordion */
  body.on('click', '.accordion .accordion-line', function (e) {
    $(this).toggleClass('opened')
  })



  // -- Table of contents
  let is_toc = $('#js-toc')
  if (is_toc.length){

    window.onload = function () {
      let toc = "";
      let level = 0;

      document.getElementById("js-single-post-content").innerHTML =
        document.getElementById("js-single-post-content").innerHTML.replace(
          /<h([\d])>([^<]+)<\/h([\d])>/gi,
          function (str, openLevel, titleText, closeLevel) {
            if (openLevel != closeLevel) {
              return str;
            }

            if (openLevel > level) {
              toc += (new Array(openLevel - level + 1)).join("<ul>");
            } else if (openLevel < level) {
              toc += (new Array(level - openLevel + 1)).join("</ul>");
            }

            level = parseInt(openLevel);

            var anchor = titleText.replace(/ /g, "_");
            toc += "<li><a href=\"#" + anchor + "\" class=\"js-go-to\" >" + titleText
              + "</a></li>";

            return "<h" + openLevel + "><a name=\"" + anchor + "\" >"
              + titleText + "</a></h" + closeLevel + ">";
          }
        );

      if (level) {
        toc += (new Array(level + 1)).join("</ul>");
      }

      document.getElementById("js-toc-content").innerHTML += toc;
    };

    $(document).on('click','.js-go-to',function(){
      let hash = $(this).attr('href').split('#')[1];
      if (hash) {
        hash = hash.replace('#', '');
        let hashEl = $('a[name="'+hash+'"]');
        if (!hashEl.length) hashEl = $('#' + hash)

        if (hashEl.length) {
          $('html, body').animate({scrollTop: hashEl.offset().top - 50}, 500);
        }
      }
      return false;
    })

  }


  $(document).on('submit','.js-blog-search-form',function(e){
    e.preventDefault()
    blog_posts.search = $(this).find('input[name="search"]').val()
    blog_posts.is_more = 1
    blog_posts.offset = 0
    let posts_list = $('#js-posts')

    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'load_more_blog_posts',
        offset: blog_posts.offset,
        cat: blog_posts.cat,
        author: blog_posts.author,
        search: blog_posts.search,
      },
      success: function (data) {
        posts_list.html(data.posts)
        blog_posts.is_more = data.is_more
        blog_posts.offset = parseInt(blog_posts.offset) + parseInt(blog_posts.per_page)
        loading = 0

        posts_list.find('.lazy-load').waypoint(function(direction) {
          let element = $(this.element)
          changeLazyLoadImage(element);
          $('.zoom-image-blur').animate({opacity:0}, 1000)
        }, {
          offset: '200%',
          triggerOnce: true
        })


      }
    })

    return false
  })



  function reset_blog_posts_obj(){
    let per_page = blog_posts.per_page
    blog_posts = {
      offset: per_page,
      cat: '',
      is_more: 1,
      per_page: per_page,
      author: '',
      search: '',
    }
  }

  /* Load posts on scroll */
  let posts_list = $('#js-posts')
  if (posts_list.length) {
    let loading = 0;
    $(window).scroll(function () {
      let posts_list = $('#js-posts')
      if ($(window).scrollTop() + $(window).height() >= posts_list.offset().top + posts_list.height() && blog_posts.is_more && !loading) {
        loading = 1

        let formData = {
          action: 'load_more_blog_posts',
          offset: blog_posts.offset,
          cat: blog_posts.cat,
          author: blog_posts.author,
          search: blog_posts.search,
        }

        $.ajax({
          type: 'POST',
          url: ajaxurl,
          data: formData,
          success: function (data) {

            posts_list.append(data.posts)
            blog_posts.is_more = data.is_more
            blog_posts.offset = parseInt(blog_posts.offset) + parseInt(blog_posts.per_page)
            loading = 0

            posts_list.find('.lazy-load').waypoint(function(direction) {
              let element = $(this.element)
              changeLazyLoadImage(element);
              $('.zoom-image-blur').animate({opacity:0}, 1000)
            }, {
              offset: '200%',
              triggerOnce: true
            })


          }
        })

      }
    });
  }

  /* Blog categories load by ajax */

  body.on('click', '.blog-category-tab', function (e) {
    e.preventDefault()

    $('.blog-category-tab').removeClass('active')
    let tab = $(this)
    tab.addClass('active')
    let term = tab.attr('data-term')
    let term_id = tab.attr('data-term-id')
    let posts_offset = tab.attr('data-offset')
    let highlight = tab.attr('data-highlight')

    reset_blog_posts_obj()
    blog_posts.cat = term_id
    window.history.pushState('page', 'Title', tab.attr('href'));

    let formData = {
      'action': 'load_blog_posts_by_category',
      'term': term,
      'offset': posts_offset,
      'highlight': highlight,
    }

    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: formData,
      success: function (data) {

        $('.js-blog-header').html(data.header)
        $('#highlighted-post-container').html(data.heading)
        $('#template-blog-posts-list').html(data.posts)

        $('.lazy-load').waypoint(function(direction) {
          let element = $(this.element)
          changeLazyLoadImage(element);
          $('.zoom-image-blur').animate({opacity:0}, 1000, function () {

          })
        }, {
          offset: '200%',
          triggerOnce: true
        })


      }
    })

    return false
  })

  body.on('click', '.pagination a', function (e) {
    e.preventDefault()
    let url = $(this).attr('href')
    let lastChar = url[url.length -1];
    let addChar = lastChar === '/' ? '' : '/'
    window.location.href = url + addChar
  })



  /* Ajax post load with waypoints */


  let post_load_target_class = $('.post-loader-target');

  let post_waypoint = post_load_target_class.waypoint(function(direction) {

    load_more_posts();

    this.destroy()

  }, {
    offset: '110%',
    triggerOnce: true
  })

  let demo_page = $('.template-demo-case-studies')
  let demo_page_description = demo_page.find('.demo-long-bottom h4')
  let demo_default_description = '';
  if(demo_page.length) {
    demo_default_description = demo_page.find('.demo-long-bottom h4').html()
  }

  body.on('click', '.load-cases-study-posts', function (e) {
    e.preventDefault()

    $('.load-cases-study-posts').removeClass('active')

    let dataLink = $(this);
    let container_ID = $('#' + dataLink.attr('data-container'));
    let post_type = dataLink.attr('data-post-type');
    let taxonomy = dataLink.attr('data-taxonomy');
    let terms = dataLink.attr('data-terms');
    let posts_per_page = parseInt(dataLink.attr('data-posts-per-page')) > 0 ? parseInt(dataLink.attr('data-posts-per-page')) : 6;
    let posts_offset = parseInt(dataLink.attr('data-offset'));
    let post_loader_data = $('#post-loader-data')

    if(dataLink.attr('data-cat-description') == 0) {
      demo_page.find('.demo-long-bottom h4').html(demo_default_description)
    } else {
      demo_page.find('.demo-long-bottom h4').html(dataLink.attr('data-cat-description'))
    }


    let formData = {
      'action': 'load_more_custom_posts',
      'post_type': post_type,
      'terms': terms,
      'taxonomy': taxonomy,
      'posts_per_page': posts_per_page,
      'offset': posts_offset,
    }

    dataLink.addClass('active')
    post_loader_data.attr('data-offset', posts_per_page)
    post_loader_data.attr('data-terms', terms)

    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: formData,
      success: function (data) {
        console.log(data)
        container_ID.html(data.posts_html);

        post_load_target_class = $('.post-loader-target');

        if(post_load_target_class.length) {
          post_waypoint = post_load_target_class.waypoint(function(direction) {

            load_more_posts();

            $('.lazy-bg').each(function(){
              changeLazyLoadImage($(this));
            })
            this.destroy()

          }, {
            offset: '110%',
            triggerOnce: true
          })

        }

      }
    })

    return false;


  })


  function load_more_posts() {

    let dataLink = $('#post-loader-data');
    let container_ID = $('#' + dataLink.attr('data-container'));
    let post_type = dataLink.attr('data-post-type');
    let taxonomy = dataLink.attr('data-taxonomy');
    let terms = dataLink.attr('data-terms');
    let posts_per_page = parseInt(dataLink.attr('data-posts-per-page')) > 0 ? parseInt(dataLink.attr('data-posts-per-page')) : 6;
    let posts_offset = parseInt(dataLink.attr('data-offset'));

    let formData = {
      'action': 'load_more_custom_posts',
      'post_type': post_type,
      'terms': terms,
      'taxonomy': taxonomy,
      'posts_per_page': posts_per_page,
      'offset': posts_offset,
    }

    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: formData,
      success: function (data) {

        post_load_target_class.remove()
        container_ID.append(data.posts_html);

        posts_offset = parseInt(posts_offset + posts_per_page);
        dataLink.attr('data-offset', posts_offset);

        post_load_target_class = $('.post-loader-target');

        if(post_load_target_class.length) {
          post_waypoint = post_load_target_class.waypoint(function(direction) {

            load_more_posts();

            $('.lazy-bg').each(function(){
              changeLazyLoadImage($(this));
            })
            this.destroy()

          }, {
            offset: '90%',
            triggerOnce: true
          })

        }
      }
    })
  }


  if(screen_width > sm && $('.pricing').length) {
    even_block_height();

    $( window ).resize(function() {
      even_block_height();
    });

  }

  function even_block_height() {

    let array_of_heights = {}

    let even_elements = $('[data-even]:visible')

    even_elements.each(function (e) {

      let element = $(this).attr('data-even')
      let height = $(this).outerHeight()

      if(typeof array_of_heights[element] !== 'undefined') {

        if(height > array_of_heights[element]) {
          array_of_heights[element] = height
        }

      } else {
        array_of_heights[element] = height
      }

    })

    for (let elem in array_of_heights) {
      $('[data-even="'+elem+'"]:visible').css('min-height', array_of_heights[elem])
    }

  }

  /* Pricing */

  body.on('click', '.show-more-price-attributes', function(e){
    e.preventDefault()
    let button = $(this)
    let attributes_block = button.closest('.attributes-block')

    if(button.parent().hasClass('opened')) {
      button.parent().removeClass('opened')
      button.text(button.attr('data-show-more'))
      attributes_block.find('.mobile-hidden').hide()
    } else {
      button.parent().addClass('opened')
      button.text(button.attr('data-show-less'))
      attributes_block.find('.mobile-hidden').show()
    }
    //$(this).parent().remove()
  })

  body.on('click', '.custom-select .item', function(e){
    e.preventDefault()
    let element = $(this)
    let currency_item_id = element.attr('value')
    let all_selects = $('.custom-select .item')
    let currency_blocks = $('[data-price-currency]')
    let current_select = $('[data-price-currency="'+currency_item_id+'"]')


    all_selects.removeClass('selected')
    currency_blocks.hide()

    element.addClass('selected')
    current_select.show()

    even_block_height()

  })

  body.on('click', '.select-price-category', function(e){
    let show_category_id = $(this).attr('id')
    $('.prices-category-block').hide()
    $('.prices-category-block[data-prices-category-block="'+show_category_id+'"]').show()
    even_block_height()

  })


  /* EOF Pricing */


  /* Contact us block */

  body.on('submit', '.contact-form', function(){

    //replace button with loader
    $('.popup').hide()
    let form = $(this)
    let formErrors = isFormValid(form)
    let loader = form.find('.loader')
    let submit_button = form.find('input[type="submit"]')
    let popup = $('.contact-us-modal')

    let input_container = $('.contact-form-container');

    if(formErrors === 0) {

      submit_button.hide()
      loader.show()
      let formData = new FormData(this);

      // add validated files to file list
      /*form.find('.uploaded-files').each(function(index, el) {
        var elId = $(this).find('input[type="file"]').attr('id');
        formData.delete(elId+'[]'); // remove originally added unvalidated files
        var files = fileListArr[elId]['files'];
        for (var i = files.length - 1; i >= 0; i--) {
          formData.append(elId+'[]', files[i], files[i].name);
        }
      });*/


      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: formData,
        success: function (data) {

          if(data.success === 1) {
            loader.hide()
            popup.show()
            submit_button.show()
            input_container.find('input[type="text"]').val('').removeClass('with-value')
            input_container.find('input[type="email"]').val('').removeClass('with-value')
            input_container.find('textarea').val('').removeClass('with-value')
            input_container.find('select').prop('selectedIndex', 0).removeClass('selected');
            let custom_select = input_container.find('.custom-select')
            if(custom_select.length) {
              let input_values = custom_select.find('.selected-item-value')
              let label = input_values.attr('data-label')
              custom_select.find('.selected-item-text').html(label)
              input_values.val('')
              custom_select.find('.selected').removeClass('selected')
            }
            input_container.find('.selected-files').html('')
            input_container.find('.uploaded-files label').show()
          }

        },
        cache: false,
        contentType: false,
        dataType: "json",
        processData: false
      });

    }

    return false;

  })

  body.on('submit', '.subscribe-form', function(){


    let form = $(this)
    let formData = form.serialize()
    let loader = form.find('.loader')
    let submit_button = form.find('input[type="submit"]')

    if(isFormValid(form) === 0) {

      let blog_subscribe = form.hasClass('blog-subscribe');

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: formData,
        success: function (data) {

          if (data.success === 1) {

            if(data.type === 'upgrading') {
              $('input[name="email"]').val('').removeClass('with-value')
                window.location = data.redirect_to
            } else {

              if(blog_subscribe) {
                let success_message = form.parent().find('.subscribed-success')
                let from_description = form.parent().find('.subscribe-description')
                let from_content = form.parent().find('.form-content')
                $('.blog-arrow').hide()
                form.hide()
                from_description.hide()
                from_content.hide()
                success_message.css('display', 'flex')
              } else if($('.template-contact-us').length) {
                if($('.contact-us-modal').length) {
                  $('.contact-us-modal').hide()
                }
                let popup = $('.template-contact-us').find('.subscribe-modal')
                popup.show()
              } else {
                let popup = form.parent().find('.subscribe-modal')
                popup.show()
              }

              $('input[name="email"]').val('').removeClass('with-value')

            }

          }
        }
      })
    }

    return false;

  })

  body.on('click', '.popup-close', function (e) {
    e.preventDefault()
    $(this).closest('.popup').hide()
    $(this).closest('.interactive-demo-popup').hide()
    body.removeClass('modal-open')
  })

  body.on('click', '.open-demo-popup', function (e) {
    e.preventDefault()
    body.addClass('modal-open')
    $(this).closest('.pulse-button-block').find('.interactive-demo-popup').show()
  })


  /** Contact form - functions **/
  function isFormValid (form) {
    let isValidForm = true
    let formFields = form.find('.validate')
    let formErrors = 0

    $('.validate').closest('.input-holder').removeClass('error')

    formFields.each(function () {

      let input = $(this)
      let input_holder = input.closest('.input-holder')
      let dataValue = input.val().trim()

      if (input.attr('data-valid') === 'email') {
        isValidForm = isValidEmail(dataValue)
      }
      if (input.attr('data-valid') === 'required') {
        isValidForm = dataValue.length > 0
      }
      if (input.attr('data-valid-checkbox') === 'required') {
        isValidForm = input.is(':checked')
      }
      if (input.attr('data-valid') === 'selected') {
        isValidForm = dataValue.length > 0
      }
      if (input.attr('data-valid') === 'custom-select') {
        input_holder = input_holder.parent()
        isValidForm = dataValue.length > 0
      }
      if (!isValidForm) {
        formErrors += 1
        input_holder.addClass('error')
      }
    })

    if (!isValidForm) {
      //show error messages
    }

    return formErrors
  }

  function isValidEmail (value) {
    var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/
    return String(value).search(filter) != -1
  }


  /* EOF Contact us */

  /* Files */

  // ------------------ validate files --------------

  var fileListArr = [];
  var filesBlockDiv = '.uploaded-files';
  var filesBlockDivLabel = $(filesBlockDiv).find('label')
  var msgDiv = '.file-message';
  var addedFilesDiv = '.selected-files';
  var maxFileSize = 8;
  var maxTotSize = 8;
  var maxFiles = 8;
  var extArr = ['jpeg','jpg','png','pdf'];
  var fileTooLarge = 'File size too big!';
  var typeNotAllowed = 'File type not allowed!';
  var tooManyFiles = 'Too many files - max allowed is '+maxFiles;
  var totSizeMsg = 'Total files size exceeded '+maxTotSize + 'MB';
  var removeFile = 'Remove attachment';


  $( '.files-input' ).each( function(){

    var $input  = $( this );

    $input.on( 'change', function( e ){

      var inputId = $(this).attr('id');
      var filesc = $(this).closest(filesBlockDiv);
      var addedFiles = filesc.find(addedFilesDiv);
      var msg = filesc.find(msgDiv);
      var fileList = [];
      var filesCount = 0;
      var totSize = 0;

      $(addedFiles).empty();
      msg.html('');

      for (var i = this.files.length - 1; i >= 0; i--) {
        filesCount++;
        var fileErr = '';
        var validateFile = 1;
        var addfiletolist = 1;

        // check file size
        var size = this.files[i].size / 1024 / 1024;
        totSize = totSize + size;
        if (size > maxFileSize) {
          validateFile = 0;
          addfiletolist = 0;
          fileErr = fileTooLarge;
        }

        // file types
        var ext = this.files[i].name.split('.').pop().toLowerCase();
        if($.inArray(ext, extArr) === -1) {
          validateFile = 0;
          addfiletolist = 0;
          fileErr = typeNotAllowed;
        }

        // files count
        if (filesCount > maxFiles){
          validateFile = 0;
          addfiletolist = 0;
          fileErr = tooManyFiles;
        }

        // file tot size
        if (totSize >= maxTotSize){
          validateFile = 0;
          addfiletolist = 0;
          fileErr = totSizeMsg;
        }

        // add to list if allowed
        if (addfiletolist == 1){
          fileList.push(this.files[i]);
          addedFiles.append('<div class="uploaded-file"><span class="icon icon-attachment mr-12"></span><span style="margin-right: auto;">'+this.files[i].name+'</span><a href="" class="remove" el="'+this.files[i].name+'" >'+removeFile+'</a></div>');
        } else {
          addedFiles.append('<div class="uploaded-file error"><span class="icon icon-attachment mr-12" style="color: red;"></span><span style="margin-right: auto;"> '+this.files[i].name+' - '+fileErr+'</span><a href="" class="remove" el="\'+this.files[i].name+\'" >'+removeFile+'</a></div>');
        }
      }

      fileListArr[inputId] = {'files':'', 'validated':0};
      fileListArr[inputId]['files'] = fileList;
      fileListArr[inputId]['validated'] = validateFile;


      filesBlockDivLabel.hide()

    });


  });

  // remove file
  body.on('click','.uploaded-files .remove', function(e){
    e.preventDefault()

    let element = $(this)
    let label = element.closest(filesBlockDiv).find('label')
    var inputId = element.closest(filesBlockDiv).find('input[type="file"]').attr('id');
    var remel = element.attr('el');
    fileListArr[inputId]['files'].splice( fileListArr[inputId]['files'].indexOf(remel), 1 );

    let line_count = element.closest('.uploaded-files').find('.uploaded-file').length - 1

    element.parent().remove();

    //let file_count = fileListArr['files']['files'].length;

    if(line_count === 0) {
      label.show()
    }

  });

  /* EOF Files */


  let we_are_upgrading_block = $('.we-are-upgrading');
  if(we_are_upgrading_block.length) {
    let input = $('.subscribe-form').find('input[name="email"]');
    let value = we_are_upgrading_block.attr('data-email')
    if(value.length > 0) {
      input.val(value).addClass('with-value')
    }
  }

  body.on('click', '.highlighted-content', function (e) {



  })

/*
  let blog_highlighted_content = $('.highlighted-content');
  if(blog_highlighted_content.length) {
    let titleWidth = blog_highlighted_content.find('.post-title').outerWidth(true)
    $('.post-categories').css('width', titleWidth - 18)
  }
*/


  let contact_us_page = $('.template-contact-us')
  if(contact_us_page.length) {
    $('.subscribe-modal').each(function (e) {

      let popup_html = $(this).clone()
      contact_us_page.append(popup_html)
      $(this).hide()

    })
  }

  body.on('click', '.popup-screen-close', function (e) {
    $(this).parent().parent().hide()
  })


  //$('.animate-this').addClass('run-animation')
  let stairs_down = $('.stairs-down')
  if(stairs_down.length) {
    $('.stairs-down').waypoint(function(direction) {
      $('.stairs-down .animate-this').addClass('run-animation')
    }, {
      offset: '70%',
      triggerOnce: true
    })
  }

  let pricing_table = $('.pricing-header')
  if(pricing_table.length) {
    $('.pricing-header .animate-this').addClass('run-animation')
  }

  let blog_top = $('.blog-top-subscribe')
  if(blog_top.length) {
    $('.blog-top-subscribe .animate-this').addClass('run-animation')
  }



  /* Front animations */
  $('.appearfadeinright').waypoint(function(direction) {
    $(this.element).addClass('visible').addClass('animated').addClass('fadeInRight');
  }, {
    offset: '105%'
  })

  $('.appearfadeinleft').waypoint(function(direction) {
    $(this.element).addClass('visible').addClass('animated').addClass('fadeInLeft');
  }, {
    offset: '105%'
  })
  $('.appearfadeinright-1').waypoint(function(direction) {
    $(this.element).addClass('visible').addClass('animated').addClass('fadeInRight');
  }, {
    offset: '140%'
  })

  $('.appearfadeinleft-1').waypoint(function(direction) {
    $(this.element).addClass('visible').addClass('animated').addClass('fadeInLeft');
  }, {
    offset: '140%'
  })


  let default_separators = $('.wp-block-separator')

  default_separators.each(function(e){
    let element = $(this)
    element.wrap('<div class="wp-block-separator"></div>')
    element.remove()
  })

  body.on('click', '.read-more-text', function (e) {
    e.preventDefault()
    let element = $(this)
    element.parent().css('display', 'none')
    let container = element.closest('.only-text-mobile-hide')
    container.find('.md-none').slideDown()

  })

  body.on('click', '.js-open-scan-field', function (e) {
    e.preventDefault()
    $('.scan-field').removeClass('sm-none').show()
  })
  body.on('click', '.js-close-scan-field', function (e) {
    e.preventDefault()
    $('.scan-field').hide()
  })





  if($('.we-are-upgrading').length && screen_width > lg) {
    let screen_height = body.height()
    $('.side-image').css('height', screen_height)
  }



  let blog_menu_slider = $('.blog-categories-menu-slider')
  let demo_case_studies_slider = $('.case-study-categories-menu-slider')
  let slider = blog_menu_slider.length ? blog_menu_slider : (demo_case_studies_slider.length ? demo_case_studies_slider : false)

  if(slider) {

    let slick_animation_slides_width = 0
    let slides_container_width = slider.find('.slick-list').width()
    let slides = slider.find('.slick-slide')

    slides.each(function (e) {
      slick_animation_slides_width += $(this).outerWidth()
    })


    if(slides_container_width > slick_animation_slides_width) {
      $('.slide-animation').removeClass('slide-animation')
    }

    slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('.slide-animation').removeClass('slide-animation')
    });

  }


  $('table').wrap('<div class="table-wrapper"></div>')

  body.on('click', '.video-storage', function (e) {
    e.preventDefault()
    window.location = $(this).attr('data-url')
  })


  /* Comments */

  $('.wc_comm_form').prepend('<div style="display: flex; align-items: center"><h3 class="mb-12">Leave a Reply</h3><a href="#" class="ml-24" id="cancel-reply-form">Cancel</a></div>')
  $('#comments').addClass('content')
  $('#wc-comment-header').hide()

  if($('.wc-comment').length) {
    $('#wc-comment-header').show()
  }

  let comments_length = $('#comments').length
  if(comments_length) {

    $('.wpdiscuz-ftb-left').hide()
    $('.wpdiscuz-front-actions').hide()

    //change to labels
    let comments_container = $('#wpcomm')
    let inputText = comments_container.find('input[type="text"]')
    let inputEmail = comments_container.find('input[type="email"]')
    let textarea = comments_container.find('textarea')
    //inputPlaceholderToLabel(inputText)
    //inputPlaceholderToLabel(inputEmail)

    let form_footer = $('.wc-form-footer')
    form_footer.css('display', 'block')
    let commentator_email = form_footer.find('input[type="email"]')
    if(commentator_email.lenght && commentator_email.val().length > 0) {
      form_footer.find('.wpd-form-col-left').hide()

    }

  }

  function inputPlaceholderToLabel(inputText) {
    inputText.each(function () {
      let input = $(this)
      let name = input.attr('name')
      input.parent().addClass('input-holder').append('<label for="'+name+'">' + input.attr('placeholder') + '</label>')
      input.attr('placeholder', '')
    })
  }

  body.on('click', '#cancel-reply-form', function (e) {
    e.preventDefault()
    $('#comments').hide()
  })

  /* EOF comments */


$(window).on('load', function() {

  if($('.owl-item').length) {

    $('.owl-item video').each(function () {
      $(this).get(0).pause()
    })

    $('.owl-item.big video').get(0).play()

  }

  let country_select = $('select[name="country"]')
  if(country_select.length) {
    country_select.select2({

    })
  }

  let default_select = $('.default-select')
  if(default_select.length) {
    default_select.select2({
      minimumResultsForSearch: Infinity
    })
  }
  // let solutions_select = $('.solutions-select')
  // if(solutions_select.length) {
  //   solutions_select.select2({
  //     //minimumResultsForSearch: Infinity
  //   })
  // }

})

$('#preloader-bg').hide()

$(window).on('load', function() {


  $('.zoom-image-blur').animate({opacity:0}, 1000, function () {

  })
  $('.video-file-container').addClass('no-blur')
  $('video').addClass('no-blur')

  $('[data-iframe-src]').waypoint(function(direction) {
    let element = $(this.element)

    let style = element.attr('data-iframe-style')
    let src = element.attr('data-iframe-src')

    element.html('<iframe src="'+src+'" width="100%" height="'+element.outerHeight()+'" style="'+style+'" data-hj-allow-iframe=""></iframe>')

  }, {
    offset: '300%',
    triggerOnce: true
  })

  $('video').waypoint(function(direction) {
    let element = $(this.element)
    let src = element.attr('data-src')
    element.prepend('<source src="'+src+'" type="video/mp4">')
  }, {
    offset: '200%',
    triggerOnce: true
  })

  $('.wp-block-columns').addClass('has-2-columns')


})

require('./ecommerce/blocks/slider')
require('./ecommerce/blocks/benefits')
require('./ecommerce/blocks/products-story')
require('./ecommerce/blocks/services')
require('./ecommerce/blocks/header')
require('./ecommerce/blocks/customers-review')
require('./ecommerce/blocks/apply-now')

require('./modal-form')

